const entities = [
	'category',
	'product',
	'product_menu',
	'category_supplement',
	'supplement',
	'price_category',
	'tax_rate',
	'exclusion',
];

let ACCESSES = entities.reduce((acc, entity) => {
	acc[entity] = {
		zone: { create: false, read: true, update: true, delete: false },
		child: { create: false, read: true, update: true, delete: false },
		default: { create: true, read: true, update: true, delete: true },
	};
	return acc;
}, {});
ACCESSES.tax_rate.child.create = true;
ACCESSES.price_category.zone.read = false;

let initialState = {
	accesses: ACCESSES,
	current: getAllAccess(ACCESSES, 'default'),
	mode: 'default',
	config: {},
};

function getAllAccess(accesses, mode) {
	return entities.reduce((acc, entity) => {
		if (
			accesses.hasOwnProperty(entity) && //FIXME:
			accesses[entity].hasOwnProperty(mode)
		) {
			acc[entity] = accesses[entity][mode];
		} else {
			acc[entity] = {
				create: false,
				read: false,
				update: false,
				delete: false,
			};
		}
		return acc;
	}, {});
}

const reducer = function accessReducer(state = initialState, action) {
	const newState = { ...state };
	switch (action.type) {
		case 'RECEIVE_ACCESS':
			return {
				...newState,
				accesses: action.data,
				// Le mode était calculé au login puis perdu ; on le conserve,
				// c'est la seule façon pour l'app de distinguer un fils
				// connecté en direct d'un compte standalone.
				mode: action.mode || newState.mode,
				current: getAllAccess(action.data, action.mode),
			};
		case 'SET_ACCESS_MODE': //FIXME: pas utilisé, delete ?
			if (action.mode) {
				return {
					...newState,
					mode: action.mode,
					current: getAllAccess(newState.accesses, action.mode),
				};
			}
			return newState;
		case 'RECEIVE_ACCESS_CONFIG':
			return {
				...newState,
				config: action.response.result,
			};
		default:
			return newState;
	}
};

export default reducer;
